/// <reference types="@types/google.maps" />

import { Html, html }	from "ts-base/web/html";

import * as commonModel	from "@geotoura/shared/commonModel";

// center and (optionally) zoom map on latlng
export const center = (map:google.maps.Map, lat:number, lng:number, zoom:number, offset?:number):void => {
	const latlng	= new google.maps.LatLng(lat, lng);
	if (zoom !== 0)	map.setZoom(zoom);
	map.panTo(latlng);
	if (offset !== undefined)	map.panBy(0, offset);
};

export const style:Array<google.maps.MapTypeStyle> = [
	{
		featureType: "poi",
		stylers: [
			{ visibility: "off" },
		],
	},
	{
		featureType: "transit.line",
		stylers: [
			{ color: "#555152" },
		],
	},
	{
		featureType: "water",
		elementType: "geometry.fill",
		stylers: [
			{ visibility: "on" },
			{ lightness: 22 },
			{ color: "#8abecc" },
		],
	},
	{
		featureType: "landscape.natural",
		stylers: [
			{ color: "#cbcece" },
			{ lightness: 60 },
		],
	},
	{
		featureType: "landscape.natural.terrain",
		elementType: "geometry.fill",
		stylers: [
			{ visibility: "on" },
			{ gamma: 0.7 },
			{ lightness: 49 },
			{ color: "#cbcece" },
		],
	},
	{
		featureType: "road",
		elementType: "labels.icon",
		stylers: [
			{ visibility: "off" },
			{ lightness: 35 },
		],
	},
	{
		elementType: "labels.text.stroke",
		stylers: [
			{ visibility: "off" },
		],
	},
	{
		elementType: "labels.text.fill",
		stylers: [
			{ visibility: "on" },
			{ color: "#696969" },
		],
	},
	{
		featureType: "road",
		elementType: "geometry.stroke",
		stylers: [
			{ visibility: "on" },
			{ color: "#fabc13" },
		],
	},
	{
		featureType: "landscape.man_made",
		elementType: "geometry.fill",
		stylers: [
			{ color: "#fabc13" },
			{ lightness: 53 },
		],
	},
];

// h is hotel, d for daytrip and a for airport, hl is the highlighted state when marker is part of the route
export const markerIcon = (type:"h"|"h-hl"|"d"|"d-hl"|"a"|"a-hl"):google.maps.Icon => ({
	url:	`/img/up/${type}.png`,
	size:	new google.maps.Size(28, 28),
	// We anchor the marker images a bit below the marker position to not obscure the town labels
	// this has the unfortunate side effect that the route polyline seems not centered on the marker
	anchor:	new google.maps.Point(14, 6),
});

const highlightColor	= "#C4533C";
const prelimColor		= "#A4A4A4";

export const pin:google.maps.Symbol = {
	path:			"M50.1,160c-3.7-18-10.2-32.9-18.1-46.8c-5.9-10.3-12.7-19.8-19-29.8c-2.1-3.3-3.9-6.8-5.9-10.3c-4-6.9-7.3-14.9-7.1-25.3c0.2-10.2,3.2-18.3,7.5-25c7-11,18.8-19.9,34.7-22.3c12.9-1.9,25.1,1.3,33.7,6.3c7,4.1,12.5,9.5,16.6,15.9c4.3,6.7,7.3,14.6,7.5,24.9c0.1,5.3-0.7,10.2-2,14.2c-1.2,4.1-3.2,7.5-5,11.2c-3.5,7.1-7.8,13.7-12.2,20.3C67.7,112.8,55.5,132.7,50.1,160z",
	fillColor:		highlightColor,
	fillOpacity:	0.8,
	anchor:			new google.maps.Point(30, 160),
	strokeColor:	highlightColor,
	strokeWeight:	1,
	scale:			0.2,
	rotation:		15,
};

export const routeLine = (type:"inRoute"|"preliminary"):Array<google.maps.IconSequence> => [
	{
		icon: {
			path:			"M 0,-1 0,1",
			strokeColor:	type === "preliminary" ? prelimColor : highlightColor,
			strokeOpacity:	1,
			scale:			3,
		},
		offset:	"0",
		repeat:	"10px",
	},
];

// TODO a11y db missing alt text
export const popup = (title:string, description:string, destinationId:commonModel.DestinationId):string =>
	Html.renderString(
		html`
			<div class="gmap-popup">
				<div class="gmap-popup-title">${title}</div>
				<div class="gmap-popup-description">${description}</div>
				<img class="gmap-popup-image" src="/p/r/200/${destinationId.toString()}_1.jpg">
			</div>
		`
	);

export const polygon = (path:Array<commonModel.Coordinate>):google.maps.Polygon =>
	new google.maps.Polygon({
		paths:			path,
		strokeColor:	"#FBBB14",
		strokeWeight:	1,
		strokeOpacity:	0.7,
		fillColor:		"#FBBB14",
		fillOpacity:	0.3,
	});

/*
// highlighting regions on map
export const polygon = (polygon:ReadonlyArray<commonModel.Coordinate>):void => {
	const polygonPath = polygon.map((val) => new google.maps.LatLng(val.lat, val.lng));

	global.regionPL	= new google.maps.Polygon({
		paths: polygonPath,
		strokeColor:	"#FBBB14",
		strokeWeight:	1,
		strokeOpacity:	0.7,
		fillColor:		'#FBBB14',
		fillOpacity:	0.3,
		map:			global.map as google.maps.Map<Element>,
	});
};
*/
